<section class="dashboard_content_sec">
  <div class="dashboard_bred_crumb">
    <ul>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li>Support Requests</li>
    </ul>
  </div>

  <section class="support_center_sec">

    <div class="grid-2">

      <!-- LEFT -->
      <div class="white-box scroll-box">
          <div class="support_center_listing">

            <h3 class="conver-title">Conversations</h3>
            <div class="support_center_listing_tophead supplies_add_form">
              <div class="support-listing-status">
                <div class="custom_tabs featured_toggle ">
                  <mat-button-toggle-group [formControl]="status" (change)="setStatus()">
                    <mat-button-toggle value="OPEN"> Open </mat-button-toggle>
                    <mat-button-toggle value="CLOSED"> Closed </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              </div>

            </div>

            <!-- SEARCH -->
            <div class="support_center_listing_head">

              <form (ngSubmit)="setSearch()">
                <div class="custom-form-group custom-form-search">
                  <div class="custom-form-control">
                    <mat-form-field appearance="outline">
                      <input type="number" matInput placeholder="Enter request number" [formControl]="search">
                      <mat-icon matSuffix>
                        <img src="../../../../../../../assets/images/icons/search_grey.svg" alt="img" class="search-icon">
                      </mat-icon>
                    </mat-form-field>
                  </div>
                </div>
              </form>
          </div>

           <!-- <hr> -->

            <div class="support_center_listing_body">
              <ng-container *ngIf="supportRequestListing;else loadingTemplate">
                <ng-container *ngIf="supportRequestListing?.length; else noDataTemplate">
                  <div class="support-list-container">
            
                    <ul>
                      <li *ngFor="let single of supportRequestListing" (click)="selectRequest(single)"
                        [ngClass]="{'active' : single?.id === selectedSupportRequest?.id}">
            
                        <div style="display: flex;gap: 8px;">
            
                          <!-- LEFT IMAGE -->
                          <div class="left-section">
            
                            <img *ngIf="single.dental_practice?.logo?.url; else supplierImg" class="user-img"
                              [src]="single.dental_practice.logo.url" />
            
                            <ng-template #supplierImg>
                              <img *ngIf="single.dental_supplier?.logo?.url; else professionalImg" class="user-img"
                                [src]="single.dental_supplier.logo.url" />
                            </ng-template>
            
                            <ng-template #professionalImg>
                              <img *ngIf="single.dental_professional?.profile_image?.url; else defaultImg" class="user-img"
                                [src]="single.dental_professional.profile_image.url" />
                            </ng-template>
            
                            <ng-template #defaultImg>
                              <img class="user-img" src="../../../../../assets/images/user-placeholder-img.svg" />
                            </ng-template>
            
                          </div>
            
                          <!-- RIGHT CONTENT -->
                          <div class="right-section">
            
                            <div class="top-row">
                              <h4 class="user-name1">
                                {{ single.dental_practice?.business_name ||
                                single.dental_supplier?.business_name ||
                                single.dental_professional?.name }}
                              </h4>
            
                              <p class="created-at">
                                {{ single.created_at | date:'dd MMM yyyy · hh:mm a' }}
                              </p>
                            </div>
            
                            <h4 class="req-number">
                              Req No : {{ single.support_request_number }}
                            </h4>
                          </div>
                        </div>
            
                        <hr style="margin: 10px 0px !important;">
            
                        <p class="reason-line">
                          <strong>Reason :</strong> {{ single.reason }}
                        </p>
            
            
                      </li>
                    </ul>
            
                  </div>
            
                </ng-container>
              </ng-container>
            
              <ng-template #loadingTemplate>
                <div class="custom-loader custom_logo_loader">
                  <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
                </div>
              </ng-template>
              <ng-template #noDataTemplate>
                <div class="no-data empty-img">
                  <!-- EMPTY-STATE -->
                  <img src='../../../../../../../assets/images/empty-imgs/no_support_req.svg' alt="img" loading="lazy" />
                  <h4 class="no_state_heading">No Support Request</h4>
                </div>
              </ng-template>
            </div>
           
          </div>
          <!-- ADD BUTTON HERE (BOTTOM-RIGHT INSIDE WHITE BOX) -->
          <button class="floating-add-btn" (click)="raiseSupport()">
            <mat-icon>add</mat-icon>
          </button>
      </div>

      <!-- RIGHT (with footer) -->
      <div class="white-box scroll-box right-wrapper">

        <ng-container *ngIf="supportRequestListing;else loadingTemplate">
          <ng-container *ngIf="supportRequestListing?.length; else noDataTemplate">
        
            <div class="right-content">
        
        
              <div class="support-header-card fixed-header">
        
                <!-- Top Bar -->
                <div class="header-top">
                  <h4 class="req-no">
                    Req : #{{ selectedSupportRequest?.support_request_number }}
                  </h4>
                  <p class="right-created-at">
                    {{ selectedSupportRequest?.created_at | date: 'dd-MMM-yyyy hh:mm a' }}
                  </p>
                </div>
        
                <!-- ITEM ROW -->
                <div class="header-content">
        
                  <!-- LEFT IMAGE -->
                  <div class="user-img-box">
        
                    <!-- PRACTICE -->
                    <img *ngIf="selectedSupportRequest?.dental_practice?.logo?.url; else supplierImg"
                      [src]="selectedSupportRequest?.dental_practice.logo.url" class="user-img" />
        
                    <!-- SUPPLIER -->
                    <ng-template #supplierImg>
                      <img *ngIf="selectedSupportRequest?.dental_supplier?.logo?.url; else professionalImg"
                        [src]="selectedSupportRequest?.dental_supplier.logo.url" class="user-img" />
                    </ng-template>
        
                    <!-- PROFESSIONAL -->
                    <ng-template #professionalImg>
                      <img *ngIf="selectedSupportRequest?.dental_professional?.profile_image?.url; else defaultImg"
                        [src]="selectedSupportRequest?.dental_professional.profile_image.url" class="user-img" />
                    </ng-template>
        
                    <!-- DEFAULT -->
                    <ng-template #defaultImg>
                      <img src="../../../../../assets/images/user-placeholder-img.svg" class="user-img" />
                    </ng-template>
        
                  </div>
        
                  <!-- RIGHT SIDE DETAILS -->
                  <div class="details">
        
                    <h4 class="user-name">
                      {{ selectedSupportRequest?.dental_practice?.business_name ||
                      selectedSupportRequest?.dental_supplier?.business_name ||
                      selectedSupportRequest?.dental_professional?.name }}
                    </h4>
        
                    <p class="user-type">
                      {{ selectedSupportRequest?.dental_practice?.type ||
                      selectedSupportRequest?.dental_supplier?.type ||
                      selectedSupportRequest?.dental_professional?.type }}
                    </p>
        
                    <p class="user-email">
                      {{ selectedSupportRequest?.dental_practice?.email ||
                      selectedSupportRequest?.dental_supplier?.email ||
                      selectedSupportRequest?.dental_professional?.email }}
                    </p>
        
                  </div>
        
                  <!-- ACTION BUTTONS -->
                  <div class="actions">
                    <button class="btn-toggle" (click)="toggleMessage()">
                      {{ isExpanded ? 'View Less' : 'View More' }}
                    </button>
                  </div>
        
                </div>
        
              </div>
        
              <!-- SCROLL AREA -->
              <div class="right-scroll-area">
        
                <div class="support-expanded-card">
        
                  <div class="support_msg_box" [@expandCollapse]="isExpanded ? 'expanded' : 'collapsed'">
        
                    <h4 style="margin-top: 5px;">Support Request Details</h4>
        
                    <div class="support-grid">
        
                      <!-- LEFT -->
                      <div class="left-column">
        
                        <div class="custom-form-group">
                          <label style="margin-bottom: 0px"><strong>Created At :</strong></label>
                          <p>{{ selectedSupportRequest?.created_at | date: 'dd-MMM-yyyy hh:mm a' }}</p>
                        </div>
        
                        <div class="custom-form-group">
                          <label style="margin-bottom: 0px"><strong>Reason :</strong></label>
                          <p>{{ selectedSupportRequest?.reason }}</p>
                        </div>
        
                        <h2 class="reason_title" *ngIf="selectedSupportRequest?.supplies_order?.order_number">
                          Order No : {{ selectedSupportRequest?.supplies_order?.order_number }}
                        </h2>
        
                        <h2 class="reason_title" *ngIf="selectedSupportRequest?.second_hand_supplies_order?.order_number">
                          Order No : {{ selectedSupportRequest?.second_hand_supplies_order?.order_number }}
                        </h2>
        
        
        
                      </div>
        
                      <!-- RIGHT - ATTACHMENTS -->
                      <div class="right-column" *ngIf="selectedSupportRequest?.attachments?.length">
        
                        <!-- <div class="custom-form-group attachment_form_group">
                          
                                      <label class="custom-label"><strong>Attachments</strong></label>
                          
                                      <div class="custom-form-control">
                                        <div *ngFor="let single of selectedSupportRequest?.attachments">
                                          <a [href]="single.url" target="_blank">
                                            <img [src]="single.url" class="preview_img">
                                          </a>
                                        </div>
                                      </div>
                          
                                    </div> -->
                        <div class="custom-form-group attachment_form_group">
        
                          <label class="custom-label"><strong>Attachments</strong></label>
        
                          <div class="custom-form-control attachments">
        
                            <div *ngFor="let file of selectedSupportRequest?.attachments; let i = index">
        
                              <!-- IMAGE -->
                              <img *ngIf="file.file_type === 'IMAGE'" [src]="file.url" class="preview_img"
                                (click)="openMsgAttachments(selectedSupportRequest.attachments, i)" />
        
                            </div>
        
                          </div>
        
                        </div>
        
        
                      </div>
        
                    </div>
        
                    <div class="custom-form-group">
                      <label style="margin-bottom: 0px"><strong>Message :</strong></label>
                      <p class="reason-line1">{{ selectedSupportRequest?.message }}</p>
                    </div>
        
                  </div>
        
                </div>
        
        
                <div *ngIf="conversationLoading" class="custom-loader custom_logo_loader">
                  <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
                </div>
        
                <div class="chat-container" *ngIf="!conversationLoading && conversationData?.length > 0">
                  <div class="chat-body" #chatBody>
                    <div class="message-row" *ngFor="let msg of conversationData"
                      [ngClass]="msg.sender_id === loginData?.id ? 'admin' : 'user'">
                      <div class="left-section" *ngIf="msg.sender_id !== loginData?.id">
                        
                        <img class="avatar" src="../../../../../assets/images/logo.svg"/>

                      </div>
        
        
                      <div class="message-bubble" [ngClass]="msg.sender_id === loginData?.id ? 'admin-bubble' : 'user-bubble'">
        
                        <!-- USER TAIL -->
                        <div *ngIf="msg.sender_id !== loginData?.id" class="bubble-tail"></div>
        
                        <!-- ADMIN TAIL -->
                        <div *ngIf="msg.sender_id === loginData?.id" class="admin-tail"></div>
        
                        <!-- TEXT MESSAGE -->
                        <p *ngIf="msg.message">{{ msg.message }}</p>
        
                        <!-- ATTACHMENTS -->
                        <div class="attachments" *ngIf="msg.attachments?.length">
                          <ng-container *ngFor="let file of msg.attachments; let i = index">
                            <!-- IMAGE -->
                            <img *ngIf="file.type === 'image'" [src]="file.url" class="msg-image"
                              (click)="openMsgAttachments(msg.attachments, i)" />
        
                            <!-- VIDEO -->
                            <div class="video-wrapper" *ngIf="file.type === 'video'"
                              (click)="openMsgAttachments(msg.attachments, i)">
                              <video class="msg-video" muted>
                                <source [src]="file.url" type="video/mp4" />
                              </video>
                              <span class="video-icon">🎥</span>
                            </div>
        
                            <!-- PDF -->
                            <div *ngIf="file.type === 'application/pdf'" class="file-icon-box pdf"
                              (click)="openMsgAttachments(msg.attachments, i)">
                              <img src="../../../../../../../assets/images/file_icons/pdf.svg" alt="">
                            </div>
        
                            <div
                              *ngIf="file.type === 'application/msword' ||
                                                              file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
                              class="file-icon-box pdf">
                              <img src="../../../../../../../assets/images/file_icons/doc.svg" />
                            </div>
                          </ng-container>
        
        
                        </div>
        
                        <!-- TIME -->
                        <span class="time">{{ msg?.created_at | date: 'hh:mm a' }}</span>
        
                      </div>
        
                    </div>
        
                  </div>
                </div>
              </div>
        
            </div>
        
            <!-- Sticky Footer -->
            <div class="right-footer">
              <form [formGroup]="raiseSupportForm">
                <div class="comment-wrapper">
                  <!-- Comment Input -->
                  <div class="comment-input-container">
                    <input type="text" placeholder="Enter message ...." formControlName="message" (keydown.enter)="sendReply(); $event.preventDefault()"/>
        
                    <label (click)="fileInput.click()"
                      style="margin-bottom: 0px !important; transform: translateY(2px); cursor: pointer;">
                      <mat-icon class="attachment-icon-cmt">attachment</mat-icon>
                    </label>
        
                    <button type="button" (click)="sendReply()">
                      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M19.6749 0.204822C19.5425 0.0972903 19.3816 0.0287808 19.2109 0.00727688C19.0403 -0.014227 18.8669 0.0121602 18.711 0.0833637L0 8.67513V10.3376L7.85899 13.4129L12.9 21H14.5998L19.9704 1.11076C20.014 0.947874 20.0093 0.77624 19.957 0.615849C19.9047 0.455458 19.8069 0.312914 19.6749 0.204822ZM13.5503 19.4143L9.21733 12.8928L15.885 5.74844L14.8301 4.80612L8.11016 12.0061L1.6304 9.47053L18.3024 1.81478L13.5503 19.4143Z"
                          fill="black" />
                      </svg>
                    </button>
                  </div>
        
                  <!-- PREVIEW SECTION FOR UPLOADED IMAGE -->
                  <input #fileInput type="file" (change)="commentFileSelected($event)" accept="image/*,.pdf,.doc,.docx" multiple
                    hidden />
        
                  <div *ngIf="commentAttachSelectedFiles.length > 0" class="image-preview-container">
                    <div *ngFor="let file of commentAttachSelectedFiles; let i = index"
                      (click)="viewcommentDocuments(commentAttachSelectedFiles,i)" class="preview-wrapper">
        
                      <img *ngIf="file.type === 'image' " [src]="file.url" class="preview-image" />
        
                      <div *ngIf="file.type === 'application/pdf'">
                        <img src="assets/images/file_icons/pdf.svg" class="preview-image" />
                      </div>
        
                      <div *ngIf="file.type === 'application/msword' ||
                                      file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'">
                        <img src="assets/images/file_icons/doc.svg" class="preview-image" />
                      </div>
        
                      <mat-icon class="remove-icon" (click)="removeFile(i)">close</mat-icon>
                    </div>
                  </div>
                </div>
              </form>
            </div>
        
          </ng-container>
        </ng-container>

           <ng-template #loadingTemplate>
                <div class="custom-loader custom_logo_loader">
                  <img src='../../../../../assets/images2/loader.gif' alt="img" loading="lazy" />
                </div>
              </ng-template>

          <ng-template #noDataTemplate>
          <div class="no-data empty-img">
            <!-- EMPTY-STATE -->
            <img src='../../../../../../../assets/images/empty-imgs/no_support_req.svg' alt="img" loading="lazy" />
            <h4 class="no_state_heading">No Support Request</h4>
          </div>
        </ng-template>

      </div>

     




    </div>

  </section>
</section>
